'use client';

import {
  Box,
  Radio,
  Typography,
  MultiColumnList,
} from '@wishket/design-system';
import { useState } from 'react';
import { twJoin } from 'tailwind-merge';

import { RoleItem, RoleCategory, Roles, RecommendRoles } from '@/shared/types';

interface RoleSelectProps {
  selectedRole: RoleItem;
  onRoleChange: (item: RoleItem) => void;
  categories?: RoleCategory[];
  roles?: Roles;
  recommendRoles?: RecommendRoles[];
  closeSelect: () => void;
}

interface RoleListProps {
  roles: { [key: string]: string };
  SelectedRole: RoleItem;
  setSelectedRole: (role: RoleItem) => void;
}

const RoleList = ({ roles, SelectedRole, setSelectedRole }: RoleListProps) => {
  return (
    <>
      {Object.entries(roles).map(([key, value]) => (
        <label key={key} className="flex items-start gap-3">
          <Box className="pt-1">
            <Radio
              isSelected={SelectedRole.key === key}
              onChange={() => {
                const selectedItem = {
                  key: key,
                  value: value,
                };
                setSelectedRole(selectedItem);
              }}
            />
          </Box>
          <Typography
            variant="body1"
            className="cursor-pointer text-w-gray-900"
          >
            {value}
          </Typography>
        </label>
      ))}
    </>
  );
};

export const RoleSelect = ({
  categories,
  roles,
  recommendRoles,
  selectedRole,
  onRoleChange,
  closeSelect,
}: RoleSelectProps) => {
  const [currentActiveCategory, setCurrentActiveCategory] = useState(0);

  if (!(categories && roles && recommendRoles)) return;

  const onSelect = (selectRole: RoleItem) => {
    onRoleChange(selectRole);
    closeSelect();
  };

  return (
    <Box
      className={twJoin(
        'flex flex-col bg-white',
        'desktop:w-[444px] desktop:rounded-xl desktop:border desktop:border-gray-200 desktop:shadow-graymedium'
      )}
    >
      <Box className="border-b px-5 pb-5 desktop:p-6">
        <MultiColumnList.Root
          currentActiveCategory={currentActiveCategory}
          onCategoryChange={setCurrentActiveCategory}
          className="h-[365px] desktop:h-[268px]"
        >
          <MultiColumnList.CategoryContainer className="w-[115px] pr-2 desktop:w-[140px]">
            <MultiColumnList.Category key={'recommend'} index={0}>
              인기
            </MultiColumnList.Category>
            {categories.map((category, index) => (
              <MultiColumnList.Category key={category.key} index={index + 1}>
                {category.kor}
              </MultiColumnList.Category>
            ))}
          </MultiColumnList.CategoryContainer>
          <MultiColumnList.ListContainer>
            {recommendRoles?.map((recommendRole) => (
              <MultiColumnList.List
                key={recommendRole.key}
                index={0}
                title={recommendRole.kor}
              >
                <RoleList
                  roles={roles[recommendRole.key]}
                  SelectedRole={selectedRole}
                  setSelectedRole={onSelect}
                />
              </MultiColumnList.List>
            ))}
            {categories.map((category, index) => (
              <MultiColumnList.List key={category.key} index={index + 1}>
                <RoleList
                  roles={roles[category.key]}
                  SelectedRole={selectedRole}
                  setSelectedRole={onSelect}
                />
              </MultiColumnList.List>
            ))}
          </MultiColumnList.ListContainer>
        </MultiColumnList.Root>
      </Box>
    </Box>
  );
};
